<template>
  <div>
    <div class="bannerContent">

      <div class="scrollContent" :style="scrolling()">
        <div v-for="(ll, li) in [list, list.slice(0, first)]" :key="li">
          <div class="bannerItems">
            <div v-for="(item, index) in ll" :key="index" v-if="index % 2 === 0">
              <img :src="item" alt="">
            </div>
          </div>
          <div class="bannerItems">
            <div v-for="(item, index) in ll" :key="index" v-if="index % 2 !== 0">
              <img :src="item" alt="">
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
let interval = null

export default {
  name: 'myPartners',
  methods: {
    scrolling: function () {
      if (this.step) {
        return {
          transform: `translateX(-${this.step * (1200 / 7)}px)`,
          transition: 'all 300ms ease-in-out'
        }
      }
      return {}
    }
  },
  data() {
    return {
      list: [],
      first: 14,
      delay: 2,
      step: 0
    }
  },
  mounted() {

    for (let i = 1; i < 47; i++) {
      this.list.push(
          require(`../../assets/image/home/partners/partners${i}.svg`)
      )
    }

    interval = setInterval(() => {
      this.step += 1

      if (this.step >= Math.ceil(this.list.length / 2)) {
        setTimeout(() => this.step = 0, 300)
      }
    }, this.delay * 1000)
  },
  destroyed() {
    clearInterval(interval)
  }
}
</script>

<style scoped>
.bannerContent * {
  box-sizing: border-box;
}

.bannerContent {
  width: 1200px;
  margin: auto;
  overflow: hidden;
}

.scrollContent {
  display: flex;
}

.bannerItems {
  display: flex;
}

.bannerItems > div {
  width: calc(1200px / 7);
  font-size: 20px;
  font-weight: bold;
  padding: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}

img {
  width: 100%;
}
</style>
